import { v5 as uuid5 } from "uuid";

export function isFloat(val: string | number): boolean {
	return Number(val) % 1 !== 0;
}

function shebaReplacer(
	match: any,
	p1: string,
	p2: string,
	p3: string,
	p4: string,
	p5: string,
	p6: string,
	p7: string,
	offset: number,
	string: string,
) {
	return [p1, p2, p3, p4, p5, p6, p7].join(" ");
}

export function shebaFormat(number: string) {
	return number.replace(/(\d{2})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{2})/, shebaReplacer);
}

export function getBaseDomain(): string {
	const host: string[] = window.location.hostname.split(".");
	return process.env.NODE_ENV === 'development' ? 'localhost' : `.${host[1]}.${host[2]}` || ".baazar.ir";
}

export function getBase64(img: Blob, callback: (arg0: string | ArrayBuffer | null) => any) {
	const reader = new FileReader();
	reader.addEventListener("load", () => callback(reader.result));
	reader.readAsDataURL(img);
}

function makeId(length: number) {
	let result = "";
	const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

export function sortKeys(obj: any) {
	const key = Object.keys(obj).sort(function order(key1, key2) {
		if (key1 < key2) {
			return -1;
		} else if (key1 > key2) {
			return +1;
		} else {
			return 0;
		}
	});

	// Taking the object in 'temp' object
	// and deleting the original object.
	const temp: any = {};

	for (let i = 0; i < key.length; i++) {
		temp[key[i]] = obj[key[i]];
		delete obj[key[i]];
	}

	// Copying the object from 'temp' to
	// 'original object'.
	for (let i = 0; i < key.length; i++) {
		obj[key[i]] = temp[key[i]];
	}
	return obj;
}

export const bzUuid = () => {
	const random = [0x10, 0x91, 0x56, 0xbe, 0xc4, 0xfb, 0xc1, 0xea, 0x71, 0xb4, 0xef, 0xe1, 0x67, 0x1c, 0x58, 0x36];
	return uuid5(makeId(10), random);
};
/**
 * Tests if children are nil in React and Preact.
 * @param {Object} children The children prop of a component.
 * @returns {Boolean}
 */
export const isNil = (children: any) =>
	children === null || children === undefined || (Array.isArray(children) && children.length === 0);

/**
 * Returns a createElement() type based on the props of the Component.
 * Useful for calculating what type a component should render as.
 *
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @param {function} [getDefault] A function that returns a default element type.
 * @returns {string|function} A ReactElement type
 */
interface GetElementTypeProps {
	href?: string;
	[prop: string]: any;
}
export function getElementType(
	Component: React.ComponentType<{ as: string }>,
	props: GetElementTypeProps,
	getDefault?: any,
) {
	const { defaultProps = {} } = Component;

	// ----------------------------------------
	// user defined "as" element type

	if (props.as && props.as !== defaultProps.as) {
		return props.as;
	}

	// ----------------------------------------
	// computed default element type

	if (getDefault) {
		const computedDefault = getDefault();
		if (computedDefault) {
			return computedDefault;
		}
	}

	// ----------------------------------------
	// infer anchor links

	if (props.href) {
		return "a";
	}

	// ----------------------------------------
	// use defaultProp or 'div'

	return defaultProps.as || "div";
}

/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */
export const getUnhandledProps = (Component: any, props: any) => {
	// Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
	const { handledProps = [] } = Component;

	return Object.keys(props).reduce((acc: any, prop: any) => {
		if (prop === "childKey") {
			return acc;
		}
		if (handledProps.indexOf(prop) === -1) {
			acc[prop] = props[prop];
		}
		return acc;
	}, {});
};

/**
 * Add Commas into number
 * @method addCommas
 * @param   {Number}  number [Number, like: 300000]
 * @return  {String}  		 [Returned String, like: 30,000]
 */
const addCommas = (num: number | string | null | undefined): string | undefined => {
	if (!num) {
		return;
	}

	const commaNum = "" + num;

	return commaNum.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export default addCommas;
